import consultationAPI from '../../api/consultation'
import summary from '../../api/customer/summary'
import customerApi from '../../api/customer/profile'
import labDocument from '../../api/customer/document'
import HealthParameters from '../../api/customer/health_parameters'
import StoreInit from '../../api/initialise_store'
import medicationsAPI from '../../api/customer/medication'
import {convertHeightToFeetInches} from '../../components/common/snackbar/helpers'
// State
const state = {
  initiated: false,
  pastConsults: [],
  activePastConsultId: null,
  activePastConsultationRequestId: null,
  currentPage: 1,
  totalPastConsults: 0
}

// Getters
const getters = {
  isPastChatPresent () {
    if (state.activePastConsultationRequestId !== null) {
      return true
    } else {
      return false
    }
  },

  getActivePastCustomer () {
    let patient = state.pastConsults.find(function (ele) {
      return (ele.consultationRequest.consultationRequestId === state.activePastConsultationRequestId)
    })
    let index = state.pastConsults.indexOf(patient)
    if (index > -1) {
      return state.pastConsults[index]
    } else {
      return {}
    }
  },

  getPastConsults () {
    return state.pastConsults
  },

  showLoadMore () {
    if (state.pastConsults.length < state.totalPastConsults) {
      return true
    } else {
      return false
    }
  }
}

// Actions
const actions = {
  init ({state, commit, dispatch}) {
    StoreInit.fetchPastConsultationsDetails().then(response => {
      if (response.status === 200) {
        dispatch('setUpPastConsults', {details: response.body.past_consults, total: response.body.total})
      }
    })
  },

  setUpPastConsults ({state, commit, dispatch}, {details, total}) {
    commit('setUpPastConsults', {details: details, total: total})
  },

  fetchMoreConsults ({state, commit, dispatch}) {
    let newPage = state.currentPage + 1
    StoreInit.fetchPastConsultationsDetails(newPage).then(response => {
      if (response.status === 200) {
        commit('loadMoreConsults', {pastConsults: response.body.past_consults})
      }
    })
  },

  loadMoreConsultsAdmin ({state, commit, dispatch}, {pastConsults}) {
    commit('loadMoreConsults', {pastConsults: pastConsults})
  },

  switchTo ({ state, commit, dispatch }, {id, consultationRequestId}) {
    commit('switchTo', {id, consultationRequestId})
    if (consultationRequestId !== null) {
      dispatch('fetchMessages', {consultationRequestId})
      dispatch('fetchCustomerProfile', {consultationRequestId})
    }
  },

  fetchCustomerProfile ({commit, state}, {consultationRequestId}) {
    let patient = state.pastConsults.find(function (ele) {
      return (ele.consultationRequest.consultationRequestId === consultationRequestId)
    })
    customerApi.getCustomerDetails(patient.customerId).then(response => {
      if (response.status === 200) {
        commit('updateCustomerDetails', {consultationRequestId: patient.consultationRequest.consultationRequestId, customerDetails: response.body.customer})
      }
    })
  },

  fetchMessages ({ commit }, {consultationRequestId}) {
    consultationAPI.getMessages(consultationRequestId).then(response => {
      if (response.status === 200) {
        let messages = response.body.messages
        commit('fetchChat', { consultationRequestId, messages })
      }
    })
  },

  addToPastConsultation ({ commit, state }, {consult}) {
    commit('addToPastConsultation', consult)
  },

  updateSummary ({commit, state}, {summary}) {
    consultationAPI.updateSummary(summary).then(response => {
      if (response.status === 200) {}
    })
  },

  reviewSummary ({ commit, state }) {
  },

  updateConsultation ({ commit, state, dispatch }, data) {
    let patient = state.pastConsults.find(function (ele) {
      return (ele.consultationRequest.consultationRequestId === state.activePastConsultationRequestId)
    })
    summary.saveSummaryDetails(data, patient.consultation.consultationId).then(response => {
      if (response.status === 200) {
        commit('updateConsultation', { consultation: response.body.consultation })
        dispatch('toaster/setToaster', {status: true, type: 'success'}, { root: true })
      } else {
        dispatch('toaster/setToaster', {status: true, type: 'error'}, { root: true })
      }
    })
  },

  sendSummary ({ commit, state, dispatch }, data) {
    let patient = state.pastConsults.find(function (ele) {
      return (ele.consultationRequest.consultationRequestId === state.activePastConsultationRequestId)
    })
    let summaryNotes = patient.consultation.summaryNotes
    if (!summaryNotes) {
      dispatch('toaster/setToaster', {status: true, type: 'error', message: 'Please add summary'}, { root: true })
    } else {
      summary.sendSummary(patient.consultation.consultationId, data.componentKey).then(response => {
        if (response.status === 200) {
          commit('updateConsultation', { consultation: response.body.consultation })
          dispatch('toaster/setToaster', {status: true, type: 'success'}, { root: true })
        } else {
          dispatch('toaster/setToaster', {status: true, type: 'error'}, { root: true })
        }
      })
    }
  },

  updateCurrentMedication ({commit, state, dispatch}, medications) {
    let patient = state.pastConsults.find(function (ele) {
      return (ele.consultationRequest.consultationRequestId === state.activePastConsultationRequestId)
    })
    medicationsAPI.update(patient.customerId, medications).then(resp => {
      if (resp.status === 200) {
        dispatch('toaster/setToaster', {status: true, type: 'success'}, { root: true })
        commit('updateCurrentMedication', {activePastConsultationRequestId: state.activePastConsultationRequestId, medications: resp.body.medications})
      } else {
        dispatch('toaster/setToaster', {status: true, type: 'error'}, { root: true })
      }
    })
  },

  summaryNotNeeded ({ commit, state, dispatch }, data) {
    let patient = state.pastConsults.find(function (ele) {
      return (ele.consultationRequest.consultationRequestId === state.activePastConsultationRequestId)
    })
    summary.summaryNotNeeded(patient.consultation.consultationId, data.componentKey).then(response => {
      if (response.status === 200) {
        commit('updateConsultation', { consultation: response.body.consultation })
        dispatch('toaster/setToaster', {status: true, type: 'success'}, { root: true })
      } else {
        dispatch('toaster/setToaster', {status: true, type: 'error'}, { root: true })
      }
    })
  },

  uploadDocuments ({ commit, state, dispatch }, formData) {
    labDocument.uploadDocuments(formData).then(response => {
      if (response.status === 200) {
        // if (response.body.lab_reports) {
        commit('updateDocuments', { consultationRequestId: state.activePastConsultationRequestId, data: response.body })
        dispatch('toaster/setToaster', {status: true, type: 'success'}, { root: true })
        // } else if (response.body.prescriptions) {
        //   commit('updatePrescriptions', { consultationRequestId: state.activePastConsultationRequestId, data: response.body.prescriptions })
        // }
      } else {
        dispatch('toaster/setToaster', { status: true, type: 'error' }, { root: true })
      }
    })
  },

  updateHealthParameters ({ commit, state, dispatch }, data) {
    let patient = state.pastConsults.find(function (ele) {
      return (ele.consultationRequest.consultationRequestId === state.activePastConsultationRequestId)
    })
    HealthParameters.updateHealthParameters(data, patient.customerId).then(response => {
      if (response.status === 200) {
        dispatch('toaster/setToaster', { status: true, type: 'success' }, { root: true })
        if (response.body.customer_health_parameters.length > 0) {
          commit('updateHealthParameter', { consultationRequestId: patient.consultationRequest.consultationRequestId, healthParameters: response.body.customer_health_parameters })
        }
      } else {
        dispatch('toaster/setToaster', { status: true, type: 'error' }, { root: true })
      }
    })
  },

  updateGeneralParameters ({commit, state, dispatch}, data) {
    let patient = state.pastConsults.find(function (ele) {
      return (ele.consultationRequest.consultationRequestId === state.activePastConsultationRequestId)
    })

    HealthParameters.updateGeneralParameters({gender: data.gender, date_of_birth: data.date_of_birth}, patient.customerId).then(response => {
      if (response.status === 200) {
        dispatch('toaster/setToaster', {status: true, type: 'success'}, { root: true })
        if (Object.keys(response.body).length > 0) {
          commit('updateCustomerDetails', { consultationRequestId: patient.consultationRequest.consultationRequestId, customerDetails: {gender: response.body.gender, date_of_birth: response.body.date_of_birth} })
        }
      } else {
        dispatch('toaster/setToaster', {status: true, type: 'error'}, { root: true })
      }
    })
    HealthParameters.updateHealthParameters({blood_group: data.blood_group}, patient.customerId).then(response => {
      if (response.status === 200) {
        dispatch('toaster/setToaster', {status: true, type: 'success'}, { root: true })
        if (response.body.customer_health_parameters.length > 0) {
          commit('updateHealthParameter', { consultationRequestId: patient.consultationRequest.consultationRequestId, healthParameters: response.body.customer_health_parameters })
        }
      } else {
        dispatch('toaster/setToaster', {status: true, type: 'error'}, { root: true })
      }
    })
  },

  setFollowUp ({commit, state, dispatch}, followUps) {
    let patient = state.pastConsults.find(function (ele) {
      return (ele.consultationRequest.consultationRequestId === state.activePastConsultationRequestId)
    })
    consultationAPI.createFollowUp({consultation_id: patient.consultation.consultationId, consultation_followup_reminders: followUps}).then(response => {
      if (response.status === 200) {
        dispatch('toaster/setToaster', { status: true, type: 'success' }, { root: true })
        commit('setFollowUp', {followUps: response.body.followup_reminders})
      } else {
        dispatch('toaster/setToaster', { status: true, type: 'error' }, { root: true })
      }
    })
  },

  reset ({commit}) {
    commit('reset')
  }
}

// Mutations
const mutations = {
  setUpPastConsults (state, {details, total}) {
    state.pastConsults = []
    state.activePastConsultId = null
    state.totalPastConsults = total
    for (let i = 0; i < details.length; i++) {
      let pc = {
        channelId: details[i].channel_id,
        customerId: details[i].customer_id,
        name: details[i].customer_name,
        isFamilyDoctor: details[i].is_family_doctor,
        familyDoctor: {id: details[i].family_doctor.id, name: details[i].family_doctor.name},
        consultationRequest: {
          consultationRequestId: details[i].consultation_request.consultation_request_id,
          chiefComplaint: details[i].consultation_request.chief_complaint,
          duration: details[i].consultation_request.duration,
          date: details[i].consultation_request.date
        },
        consultation: {
          chiefComplaint: details[i].consultation.chief_complaint,
          consultationId: details[i].consultation.consultation_id,
          provisionalDiagnosis: details[i].consultation.provisional_diagnois,
          summaryNotes: details[i].consultation.summary,
          date: details[i].consultation.date,
          summary_status: details[i].consultation.summary_status,
          prescribedDrugs: details[i].consultation.prescribed_drugs,
          followupReminders: details[i].consultation.followup_reminders,
          recommendedTests: details[i].consultation.recommended_tests
        },
        details: {},
        messages: []
      }
      state.pastConsults.push(pc)
    }
    state.initiated = true
  },

  switchTo (state, {id, consultationRequestId}) {
    state.activePastConsultId = id
    state.activePastConsultationRequestId = consultationRequestId
  },

  fetchChat (state, { consultationRequestId, messages }) {
    let consult = state.pastConsults.find(function (ele) {
      return (ele.consultationRequest.consultationRequestId === consultationRequestId)
    })
    let index = state.pastConsults.indexOf(consult)
    if (index > -1) {
      let timeInMilliSeconds = new Date().getTime()
      if (messages.length > 0) {
        timeInMilliSeconds = messages[0].uniqueId
      }
      let chiefComp = consult.consultationRequest.chiefComplaint
      let duration = consult.consultationRequest.duration
      if (!chiefComp) {
        chiefComp = 'Patient did not answer this.'
      }
      if (!duration) {
        duration = 'Patient did not answer this.'
      }
      let topMsgs = [
        { payload: { text: 'please let us know your health issue' }, status: 'read', uniqueId: timeInMilliSeconds, timestamp: timeInMilliSeconds, intentName: 'incoming_text', user: { type: 'doctor' } },
        { payload: { text: chiefComp }, status: 'read', uniqueId: timeInMilliSeconds, timestamp: timeInMilliSeconds, intentName: 'incoming_text', user: { type: 'customer' } }
        // { payload: { text: 'How long have you been having this issue?' }, status: 'read', uniqueId: timeInMilliSeconds, intentName: 'incoming_text', user: { type: 'doctor' } },
        // { payload: { text: duration }, status: 'read', uniqueId: timeInMilliSeconds, intentName: 'incoming_text', user: { type: 'customer' } }
      ]
      let msgs = topMsgs.concat(messages)
      state.pastConsults[index].messages = msgs
    }
  },

  updateCustomerDetails (state, {consultationRequestId, customerDetails}) {
    let consult = state.pastConsults.find(function (ele) {
      return (ele.consultationRequest.consultationRequestId === consultationRequestId)
    })
    let index = state.pastConsults.indexOf(consult)
    if (index > -1) {
      if (Object.keys(customerDetails).length === 2) {
        state.pastConsults[index].details.date_of_birth = customerDetails.date_of_birth
        state.pastConsults[index].details.gender = customerDetails.gender
      } else {
        state.pastConsults[index].details = customerDetails
      }
    }
  },

  updateCurrentMedication (state, { activePastConsultationRequestId, medications }) {
    let consult = state.pastConsults.find(function (ele) {
      return (ele.consultationRequest.consultationRequestId === state.activePastConsultationRequestId)
    })
    let index = state.pastConsults.indexOf(consult)
    if (index > -1) {
      state.pastConsults[index].details.medications = medications
    }
  },

  addToPastConsultation (state, consult) {
    let pc = state.pastConsults.find(function (ele) {
      return (ele.consultationRequest.consultationRequestId === consult.consultationRequest.consultationRequestId)
    })
    let index = state.pastConsults.indexOf(pc)
    if (index < 0) {
      let latestPc = {
        channelId: consult.channelId,
        customerId: consult.customerId,
        name: consult.name,
        isFamilyDoctor: consult.isFamilyDoctor,
        consultationRequest: consult.consultationRequest,
        consultation: consult.consultation,
        messages: consult.messages
      }
      if (!consult.isFamilyDoctor && consult.familyDoctor) {
        latestPc.familyDoctor = {id: consult.familyDoctor.id, name: consult.familyDoctor.name}
      }
      state.pastConsults.unshift(latestPc)
      state.totalPastConsults ++
    }
  },

  updateConsultation (state, {consultation}) {
    let patient = state.pastConsults.find(function (ele) {
      return (ele.consultationRequest.consultationRequestId === state.activePastConsultationRequestId)
    })
    let index = state.pastConsults.indexOf(patient)
    if (index > -1) {
      state.pastConsults[index].consultation.chiefComplaint = consultation.chief_compliant
      state.pastConsults[index].consultation.provisionalDiagnosis = consultation.provisional_diagnois
      state.pastConsults[index].consultation.summaryNotes = consultation.summary_notes
      state.pastConsults[index].consultation.summary_status = consultation.summary_status
    }
  },

  updateDocuments (state, { consultationRequestId, data }) {
    let patient = state.pastConsults.find(function (ele) {
      return (ele.consultationRequest.consultationRequestId === consultationRequestId)
    })
    let index = state.pastConsults.indexOf(patient)
    if (index > -1) {
      state.pastConsults[index].details.documents.push(data)
    }
  },

  // updatePrescriptions (state, { consultationRequestId, data }) {
  //   let patient = state.pastConsults.find(function (ele) {
  //     return (ele.consultationRequest.consultationRequestId === consultationRequestId)
  //   })
  //   let index = state.pastConsults.indexOf(patient)
  //   if (index > -1) {
  //     state.pastConsults[index].details.prescriptions = state.pastConsults[index].details.prescriptions.concat(data)
  //   }
  // },

  updateHealthParameter (state, { consultationRequestId, healthParameters }) {
    let patient = state.pastConsults.find(function (ele) {
      return (ele.consultationRequest.consultationRequestId === consultationRequestId)
    })
    let index = state.pastConsults.indexOf(patient)
    if (index > -1) {
      healthParameters.map(function (param) {
        state.pastConsults[index].details.health_parameters[param.question_tag] = param.result
        if (param.question_tag === 'height') {
          let answer = convertHeightToFeetInches(param.result)
          state.pastConsults[index].details.health_parameters['feet'] = answer[0]
          state.pastConsults[index].details.health_parameters['inches'] = answer[1]
        }
      })
    }
  },

  setFollowUp (state, {followUps}) {
    let patient = state.pastConsults.find(function (ele) {
      return (ele.consultationRequest.consultationRequestId === state.activePastConsultationRequestId)
    })
    if (patient) {
      let i = state.pastConsults.indexOf(patient)
      state.pastConsults[i].consultation.followupReminders = followUps
    }
  },

  reset (state) {
    state.pastConsults = []
    state.activePastConsultId = null
    state.activePastConsultationRequestId = null
  },

  loadMoreConsults (state, {pastConsults}) {
    if (pastConsults.length > 0) {
      state.currentPage += 1
    }
    for (let i = 0; i < pastConsults.length; i++) {
      let pc = {
        channelId: pastConsults[i].channel_id,
        customerId: pastConsults[i].customer_id,
        name: pastConsults[i].customer_name,
        isFamilyDoctor: pastConsults[i].is_family_doctor,
        familyDoctor: {id: pastConsults[i].family_doctor.id, name: pastConsults[i].family_doctor.name},
        consultationRequest: {
          consultationRequestId: pastConsults[i].consultation_request.consultation_request_id,
          chiefComplaint: pastConsults[i].consultation_request.chief_complaint,
          duration: pastConsults[i].consultation_request.duration,
          date: pastConsults[i].consultation_request.date
        },
        consultation: {
          chiefComplaint: pastConsults[i].consultation.chief_complaint,
          consultationId: pastConsults[i].consultation.consultation_id,
          provisionalDiagnosis: pastConsults[i].consultation.provisional_diagnois,
          summaryNotes: pastConsults[i].consultation.summary,
          date: pastConsults[i].consultation.date,
          summary_status: pastConsults[i].consultation.summary_status,
          prescribedDrugs: pastConsults[i].consultation.prescribed_drugs,
          followupReminders: pastConsults[i].consultation.followup_reminders,
          recommendedTests: pastConsults[i].consultation.recommended_tests
        },
        details: {},
        messages: []
      }
      state.pastConsults.push(pc)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/past_consultation.js